import { memoize } from '@exodus/basic-utils';
import lodash from 'lodash';
const { get } = lodash;
const resultFunction = (remoteConfig, assets) => memoize((fromAssetName, toAssetName) => {
    const getAssetStatusResolved = (assetName, direction) => {
        const getStatusObject = (assetName) => {
            return get(remoteConfig, ['assets', assetName, 'status']) || {};
        };
        const oppositeDirection = direction === 'to' ? 'from' : 'to';
        const baseAsset = assets[assetName]?.baseAsset;
        if (!baseAsset)
            return {};
        let baseAssetStatus = getStatusObject(baseAsset.name);
        if (baseAssetStatus.exchangeDirection === oppositeDirection)
            baseAssetStatus = {};
        if (!baseAssetStatus.exchangeIncludeTokens)
            baseAssetStatus = {};
        let assetStatus = getStatusObject(assetName);
        if (assetStatus.exchangeDirection === oppositeDirection)
            assetStatus = {};
        return assetStatus.exchangeTitle || assetStatus.exchangeText ? assetStatus : baseAssetStatus;
    };
    const fromAssetStatus = getAssetStatusResolved(fromAssetName, 'from');
    const toAssetStatus = getAssetStatusResolved(toAssetName, 'to');
    const status = fromAssetStatus.exchangeTitle || fromAssetStatus.exchangeText
        ? fromAssetStatus
        : toAssetStatus;
    return {
        exchangeWarningTitle: status.exchangeTitle || null,
        exchangeWarningText: status.exchangeText || null,
    };
}, (fromAssetName, toAssetName) => `${fromAssetName}-${toAssetName}`);
const remoteWarningSelectorDefinition = {
    id: 'remoteWarning',
    resultFunction,
    dependencies: [
        { selector: 'data', module: 'remoteConfig' },
        { selector: 'all', module: 'assets' },
    ],
};
export default remoteWarningSelectorDefinition;
